<app-breadcrumbs [breadcrumbs]="breadScrumbArr"></app-breadcrumbs>

<div class="container-fluid pt-5 pb-5" style="background-color: #f0f0f0;">
    <div class="text-center" *ngIf="Cat != null"><h3 style="color: #323232"> {{Cat[0]?.name}}</h3></div>
    <div class="text-center container" style="margin: auto;">


        <!--        <owl-carousel-o *ngIf="subCat.length > 0;" [options]="customOptions">-->
        <!--            <ng-template *ngFor="let cat of subCat" carouselSlide>-->

        <div *ngIf="subCat.length == 0 && noChildren == true" class="row">
            <div class="col-3 ">
                <app-category-block-shimmer></app-category-block-shimmer>
            </div>
            <div class="col-3">
                <app-category-block-shimmer></app-category-block-shimmer>
            </div>
            <div class="col-3">
                <app-category-block-shimmer></app-category-block-shimmer>
            </div>
            <div class="col-3">
                <app-category-block-shimmer></app-category-block-shimmer>
            </div>
        </div>

        <div *ngIf="subCat.length > 0" class="row">
            <div class="col-md-3 col-sm-12" *ngFor="let cat of subCat">


                <app-category-block [cat]="cat" [catDet]="FullCategories"></app-category-block>
            </div>
        </div>

        <!--            </ng-template>-->

        <!--        </owl-carousel-o>-->
    </div>
</div>


<div class="container overflow-hidden ">


    <br>

    <app-products-grid [ProductDataSet]="ProductDataSet">

    </app-products-grid>
    <!--    <app-product-slider *ngIf="Cat[0] != null" [id]="Cat[0].id" [ProductDataSet]="ProductDataSet"></app-product-slider>-->


</div>

